import { meta as archMeta } from "./architecture";
import { meta as reqMeta } from "./requirements";

export function AboutOverview() {
  return (
    <div style={{ display: "grid", gap: 24 }}>
      <section className="card" style={{ padding: 28 }}>
        <h2 style={{ font: "var(--t-headline-sm)", marginTop: 0 }}>What is AIDAN?</h2>
        <p style={{ font: "var(--t-body-lg)", color: "var(--md-on-surface-var)", maxWidth: 720 }}>
          {archMeta.productSummary}
        </p>
      </section>

      <section>
        <div className="lex-eyebrow" style={{ marginBottom: 12 }}>AT A GLANCE</div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))", gap: 12 }}>
          {archMeta.kpis.map((k) => (
            <div key={k.label} className="card" style={{ padding: 18 }}>
              <div style={{ font: "var(--t-label-md)", color: "var(--md-on-surface-var)" }}>{k.label}</div>
              <div style={{ font: "var(--t-headline-md)", fontStyle: "italic", color: "var(--md-primary)" }}>{k.value}</div>
              {k.hint && <div style={{ font: "var(--t-body-sm)", color: "var(--md-on-surface-var)" }}>{k.hint}</div>}
            </div>
          ))}
          <div className="card" style={{ padding: 18 }}>
            <div style={{ font: "var(--t-label-md)", color: "var(--md-on-surface-var)" }}>Requirements</div>
            <div style={{ font: "var(--t-headline-md)", fontStyle: "italic", color: "var(--md-primary)" }}>
              {reqMeta.implementedCount}/{reqMeta.totalCount}
            </div>
            <div style={{ font: "var(--t-body-sm)", color: "var(--md-on-surface-var)" }}>
              {reqMeta.partialCount} partial · {reqMeta.plannedCount} planned
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="lex-eyebrow" style={{ marginBottom: 12 }}>WHO IT'S FOR</div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))", gap: 12 }}>
          {archMeta.personas.map((p) => (
            <div key={p.name} className="card" style={{ padding: 20 }}>
              <div style={{ font: "var(--t-title-md)", marginBottom: 4 }}>{p.name}</div>
              <span className="lex-chip" data-tone="secondary" data-size="sm">{p.role}</span>
              <p style={{ marginTop: 12, color: "var(--md-on-surface-var)", font: "var(--t-body-md)" }}>{p.description}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="card" style={{ padding: 24 }}>
        <h3 style={{ font: "var(--t-title-md)", marginTop: 0 }}>Product principles</h3>
        <ul style={{ paddingLeft: 18, color: "var(--md-on-surface-var)", font: "var(--t-body-md)", display: "grid", gap: 6 }}>
          <li>Provenance over speed — every change is approvable and traceable.</li>
          <li>The edge is the runtime — D1, R2, and Workers, globally.</li>
          <li>Stewards before APIs — humans review what machines propose.</li>
          <li>Quality is a first-class object, not a script.</li>
        </ul>
      </section>
    </div>
  );
}

export default AboutOverview;
